module.exports = __webpack_public_path__ + "img/Component 191 – 2.cb3c5361.svg";